import React, { useMemo, useRef } from "react";
import { bool, func, number, oneOfType, shape, string } from "prop-types";
import { v4 as uuid } from "uuid";

import * as S from "../styled";

const ToggleItem = props => {
  const { item, onChange } = props;
  const inputRef = useRef(null);
  const id = useMemo(() => uuid(), []);

  const disabled = useMemo(() => props.disabled || item.disabled, [
    props.disabled,
    item.disabled
  ]);

  const handleKeyPress = event => {
    if (event.key === "Enter") {
      inputRef.current.click();
    }
  };

  return (
    <S.ToggleItemWrapper data-qa="toggle-button">
      <S.ToggleRadio
        ref={inputRef}
        id={id}
        {...item}
        {...props}
        disabled={disabled}
        onChange={onChange}
      />
      <S.BaseTabWrapper
        data-qa={`${props.name}_${item.value}`}
        htmlFor={id}
        onKeyPress={handleKeyPress}
      >
        {item?.text} {item?.subtext}
      </S.BaseTabWrapper>
    </S.ToggleItemWrapper>
  );
};

ToggleItem.propTypes = {
  disabled: bool,
  item: shape({
    disabled: bool,
    subtext: string,
    text: string,
    value: oneOfType([bool, number, string])
  }),
  name: string,
  onChange: func
};

ToggleItem.defaultProps = {
  disabled: false,
  item: { disabled: false },
  name: "",
  onChange: () => {}
};

export default ToggleItem;
